module.exports = __webpack_public_path__ + "img/reject.32f01461.png";